import axios from 'axios'

const endpoints = {
  configuration: process.env.REACT_APP_ENDPOINT_DOLLI + '/config?',
  events: process.env.REACT_APP_ENDPOINT_EVENTS + '/bin/events.json'
}

export const configuration = currentLanguage => {
  return axios.get(endpoints.configuration + currentLanguage.toString())
}

export const events = () => {
  return axios.get(endpoints.events)
}

export default endpoints
